<template>
  <v-container fluid>
    <v-card class="pa-8">
      <v-layout row wrap>
        <v-flex xs12 sm6 md2>
          <v-menu
            ref="menuBegin"
            v-model="menuBegin"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="dateBegin"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormattedBegin"
                label="Начало"
                readonly
                v-on="on"
                persistent-hint
                prepend-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
              :allowed-dates="allowedBeginDate"
              v-model="dateBegin"
              no-title
              scrollable
              locale="ru-RU"
            >
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="menuBegin = false">Отмена</v-btn>
              <v-btn color="primary" @click="$refs.menuBegin.save(dateBegin)"
                >Применить</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-menu
            ref="menuEnd"
            v-model="menuEnd"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="dateEnd"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormattedEnd"
                label="Конец"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              :allowed-dates="allowedEndDate"
              v-model="dateEnd"
              no-title
              scrollable
              locale="ru-RU"
            >
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="menuEnd = false">Отмена</v-btn>
              <v-btn color="primary" @click="$refs.menuEnd.save(dateEnd)"
                >Применить</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-row class="checkbox-container  mb-4" dense>
          <v-col
            cols="auto"
            v-for="(software, id) in softwareData"
            :key="id"
          >
            <v-checkbox
              v-model="selected"
              :label="software"
              :value="id"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-layout>
      <v-layout>
        <v-btn
          @click="applySelection"
          variant="flat"
          color="green"
          dark
        >
          Применить фильтр
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="createExcel"
          variant="flat"
          :color="hasData ? 'green' : 'grey'"
          dark
        >
          Выгрузить в xlsx
        </v-btn>
      </v-layout>
  
      <br />
  
      <v-card v-if="showChartTable">
        <LineChart :chartXData="chartXDataArray" :chartYData="chartYDataArray" :yTitle="'Количество экземпляров ПО'" :title="'Статистика по экземплярам ПО'" />
      </v-card>
  
      <br />
  
      <v-card v-if="showChartTable">
        <Table :headersTable="headersTable" :itemsTable="itemsTable" />
      </v-card>
  
      <v-card v-else>
        <div class="no-data-message">
          Нет данных для создания графика и таблицы
        </div>
      </v-card>
    </v-card>
  </v-container>
</template>


<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import LineChart from "./LineChart.vue";
import Table from "./Table.vue";
import SOFTWARE_CODES from '../../../constants.js';

export default {
  components: {
    LineChart,
    Table,
  },
  watch: {
    analyticsData: {
      handler() {
        this.hasData = this.analyticsData.length !== 0;
        this.showChartTable = this.analyticsData.length !== 0;
      },
    }
  },
  data() {
    const beginDate = new Date();
    beginDate.setDate(beginDate.getDate() - 30);
    const endDate = new Date();
    endDate.setDate(endDate.getDate() - 1);

    return {
      selected: SOFTWARE_CODES,

      dateBegin: beginDate.toISOString().substring(0, 10),
      dateEnd: endDate.toISOString().substring(0, 10),
      menuBegin: false,
      menuEnd: false,
      hasData: null,
      showChartTable: null,
    };
  },
  computed: {
    ...mapGetters([
      "analyticsData",
      "chartXDataArray",
      "chartYDataArray",
      "softwareData",
      "url",
    ]),
    dateFormattedBegin: {
      get() {
        return this.formatDate(this.dateBegin);
      },
      set(value) {
        this.dateBegin = this.parseDate(value);
      },
    },
    dateFormattedEnd: {
      get() {
        return this.formatDate(this.dateEnd);
      },
      set(value) {
        this.dateEnd = this.parseDate(value);
      },
    },
    itemsTable() {
      return this.analyticsData;
    },
    headersTable() {
      return this.createTableArray();
    },
  },
  async created() {
    await this.createAnalyticsData({
      dateBegin: this.dateBegin,
      dateEnd: this.dateEnd,
      data: this.selected,
    });
    await this.createSoftwareData();
  },
  methods: {
    ...mapActions([
      "createAnalyticsData",
      "createSoftwareData",
      "createExcelFile",
      "createSoftwareNamesArray",
    ]),
    ...mapMutations(['setSnackbar']),
    allowedEndDate(date) {
      const endDate = new Date();
      endDate.setDate(endDate.getDate() - 1);
      const dateEnd = endDate.toISOString().substring(0, 10);
      return date <= dateEnd && date >= this.dateBegin;
    },
    allowedBeginDate(date) {
      return date <= this.dateEnd;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    async applySelection() {
      await this.createAnalyticsData({
        dateBegin: this.dateBegin,
        dateEnd: this.dateEnd,
        data: this.selected,
      });
    },
    async createExcel() {
      if (this.analyticsData.length !== 0) {
        try {
          const data = {
            "headers": this.headersTable,
            "body": this.itemsTable
          };
          // console.log(data)
          const response = await axios.post(
            this.url + "reports",
            data,
            {
              responseType: "blob",
            }
          );
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "report.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          const snackbar = {
                        show: true,
                        message: error,
                        color: 'error'
                    };
          this.setSnackbar(snackbar)
          console.error("Ошибка при загрузке файла:", error);
        }
      }
    },
    createTableArray() {
      const data = [{ text: "Дата", sortable: false, value: "date" }];
      for (const key in this.softwareData) {
        const softName = this.softwareData[key];
        data.push({ text: softName, sortable: false, value: softName });
      }
      // console.log(data)
      return data;
    },
  },
};
</script>


<style scoped>
.no-data-message {
  text-align: center;
  padding: 20px;
}
.checkbox-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

}
</style>
